export default {"src":"/_next/static/media/search.01ba7d36.svg","height":24,"width":24};